<template>
  <div class="container">
    <div class="row mb-5">
      <div class="col-12">
        <h4 class="mt-4">Gerar link para solicitar app com tempo</h4>
      </div>

      <div class="col-9 mt-2">
        <label>Data de expiração do cadastro:</label> <span class="ml-2" style="color:red">FORMATO DA DATA/HORA (2023-12-30 22:59:59)</span>
        <input type="text" class="form-control" v-model="data" v-mask="'####-##-## ##:##:##'" placeholder="aaaa-mm-dd hh:mm:ss">
      </div>

      <div class="col-3 mt-2 align-self-end ml-auto">
        <button class="btn btn-success btn-block" @click="gerarLink()">Gerar link</button>
      </div>

      <div class="col-9 mt-2">
        <label>Url para cadastro:</label>
        <input type="text" class="form-control" v-model="url" readonly>
      </div>

      <div class="col-3 mt-2 align-self-end ml-auto">
        <button class="btn btn-success btn-block" @click="copiarUrl()">Copiar url</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CalcCustos',
  data() {
    return {
      data: '',
      url: '',
    };
  },
  methods: {
    gerarLink() {
      var site = process.env.VUE_APP_CURRENT_SITE_ADDRESS;
      var path = '/solicitar-app';
      var base64 = btoa(this.data);

      this.url = site+path+'?value='+base64;
    },
    copiarUrl() {
      navigator.clipboard.writeText(this.url);
      this.makeToast('Sucesso!', 'Url copiado com sucesso!', 'success');
    },
    
  },
};
</script>
<style scoped>

</style>
